export type FrequentFlyerField = keyof Omit<App.BusinessTraveller.TravellerFormLoyaltyPrograms, 'hotelLoyaltyProgramMemberId'>

export const frequentFlyerNumberTravellerFormFields: Array<[airlineField: FrequentFlyerField, numberField: FrequentFlyerField]> = [
  ['frequentFlyerAirline1', 'frequentFlyerNumber1'],
  ['frequentFlyerAirline2', 'frequentFlyerNumber2'],
]
